import React from 'react';
import { Label, Select, ErrorText } from '../lib';

const SelectInputSimple = React.forwardRef((props, ref) => {
    const { label, options, error, ...rest } = props;

    return (
        <div style={{ marginBottom: '10px', width: '100%' }}>
            <Label htmlFor={rest.name}>{label}</Label>
            <Select ref={ref} {...rest}>
                <option value={''}> {label} </option>
                {options && options.map((option, key) => <option key={key} value={option.value}> {option.label} </option>)}
            </Select>
            {error && <ErrorText>{error}</ErrorText>}
        </div>
    )
});

export default SelectInputSimple;
